export const MAX_PRICE_IMPACT = 5; // 5%
export const MINIMUM_LIQUIDITY = 1000n;
